import gravite from '../assets/gravite.png';
import evitara from '../assets/evitara.png';
import kushaq from '../assets/skodakushaq.png';

const carBlogs = [
  {
    id: 1,
    image: gravite,
    title: "Nissan Gravite Gets CNG Upgrade: Affordable MPV Goes Greener",
    author: "Admin",
    date: "4 May 2026",
    description: "Nissan has introduced a twin-cylinder CNG retrofit option for the Gravite MPV, making it more fuel-efficient and budget-friendly. The kit is available across dealerships and comes with warranty support, targeting cost-conscious family buyers." 
  },
  {
    id: 2,
    image: evitara,
    title: "Maruti e Vitara Sees Massive Demand for 61kWh Variants",
    author: "Admin",
    date: "2 May 2026",
    description: "Maruti Suzuki reports strong demand for the higher-range 61kWh variants of the e Vitara EV. With advanced features like ADAS and dual screens, the electric SUV is emerging as a key player in India’s growing EV market." 
  },
  {
    id: 3,
    image: kushaq,
    title: "Skoda Kushaq Facelift Gains Traction in 2026 SUV Market",
    author: "Admin",
    date: "April 2026",
    description: "The 2026 Skoda Kushaq facelift brings updated styling, improved interiors, and new automatic transmission options. With refreshed features and competitive pricing, it continues to challenge rivals in the midsize SUV segment." 
  }
];

export default carBlogs;
